// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1326":"3f574ec1","1823":"7fbd5ed4","2642":"72a8a4ce","4547":"f5ac6a4e","9525":"7fbd5ed4"}[chunkId] + ".chunk.css";
};